/**
 *
 * FBSectionHeader
 *
 */

import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// styles
import "./style.scss";

// layout components
import Preloader from 'components/Preloader';

// icons
import CustomIcons from "components/CustomIcons";

import { getCommunicationTypeLabel } from "utils/helpers/helper.generateData";

function FBSectionHeader({
  type,
  mode,
  loading,
  // actions
  onDelete,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("tcf-fb-section-header", type, className);

  const onDeleteHandler = useCallback(() => {
    !!onDelete && !!!loading && onDelete(type);
  }, [onDelete, loading]);

  return (
    <div {...rest} className={childClassNames}>
      <div className="header-wrapper">
        <div className={`header-tag header-tag--${type}`}>
          {getCommunicationTypeLabel(type)?.label}
        </div>
      </div>
      <div className="header-actions">
        {!!onDelete && mode != "onlyRead" && mode != "preview" && (
          <div className="delete-action-wrapper">
            {!loading && (
              <CustomIcons
                className={`header-actions__button ${type}`}
                type="garbage"
                onClick={onDeleteHandler}
              />
            )}
            {!!loading && <Preloader size="small" />}
          </div>
          
        )}
      </div>
    </div>
  );
}

FBSectionHeader.defaultProps = {
  type: "documents",
  mode: "edit",
  loading: false,
};
FBSectionHeader.propTypes = {
  type: PropTypes.oneOf(["appointments", "forms", "documents", "discussion"])
    .isRequired,
  mode: PropTypes.oneOf(["edit", "onlyRead", "preview", "new"]).isRequired,
  onDelete: PropTypes.func,
};

export default memo(FBSectionHeader);
